"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetsDropdownItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var FormattedPreview_1 = require("../customFormatDialog/shared/FormattedPreview");
var PresetsDropdownItem = /** @class */ (function (_super) {
    tslib_1.__extends(PresetsDropdownItem, _super);
    function PresetsDropdownItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            var _a = _this.props, preset = _a.preset, onClick = _a.onClick;
            onClick(preset);
            e.preventDefault();
        };
        return _this;
    }
    PresetsDropdownItem.prototype.render = function () {
        var _a = this.props, preset = _a.preset, separators = _a.separators, isSelected = _a.isSelected;
        var localIdentifier = preset.localIdentifier, name = preset.name, previewNumber = preset.previewNumber, format = preset.format;
        var className = classnames_1.default("gd-list-item", "gd-format-preset", "s-format-preset-" + localIdentifier, "s-format-preset-name-" + util_1.stringUtils.simplifyText(name), {
            "is-selected": isSelected,
        });
        return (react_1.default.createElement("div", { className: className, onClick: this.handleOnClick },
            react_1.default.createElement("span", { title: name, className: "gd-format-preset-name gd-list-item-shortened" }, name),
            previewNumber !== null && format !== null && (react_1.default.createElement(FormattedPreview_1.FormattedPreview, { previewNumber: previewNumber, format: format, separators: separators, colors: false, className: "gd-format-preset-preview" }))));
    };
    PresetsDropdownItem.defaultProps = {
        isSelected: false,
    };
    return PresetsDropdownItem;
}(react_1.default.PureComponent));
exports.PresetsDropdownItem = PresetsDropdownItem;
//# sourceMappingURL=PresetsDropdownItem.js.map